import { render, staticRenderFns } from "./CalendarAxisX.vue?vue&type=template&id=61b1e5a6&scoped=true&"
import script from "./CalendarAxisX.vue?vue&type=script&lang=js&"
export * from "./CalendarAxisX.vue?vue&type=script&lang=js&"
import style0 from "./CalendarAxisX.vue?vue&type=style&index=0&id=61b1e5a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b1e5a6",
  null
  
)

export default component.exports